import React from 'react'
// import { Link } from 'react-router-dom'
import FooterOne from './FooterOne'

// FooterFour is the same as FooterOne for now
// This allows flexibility to customize FooterFour separately if needed later
function FooterFour() {
    return <FooterOne />
}

export default FooterFour


